import type { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions'

import { typo } from 'shared/styles'
import { StackIcon } from 'shared/ui'

import css from './CustomPagination.module.scss'

export function Actions({
	count = 0,
	disabled,
	getItemAriaLabel,
	onPageChange,
	page = 0,
	rowsPerPage = 5,
	showFirstButton,
	showLastButton
}: TablePaginationActionsProps) {
	const pageTotal = Math.ceil(count / rowsPerPage),
		isLast = page + 1 === pageTotal,
		isStart = page === 0

	const setPaginationInform = () => {
		const startPosition = page * rowsPerPage + 1
		let lastPosition = (page + 1) * rowsPerPage
		if (lastPosition > count) {
			lastPosition = count
		}

		return `${startPosition}-${lastPosition} of ${count}`
	}

	return (
		<div className={css.pagination}>
			{showFirstButton && (
				<button
					className={css.action}
					disabled={isStart || disabled}
					onClick={e => onPageChange(e, 0)}
				>
					<StackIcon
						className={css.prev}
						icon='arrow-double'
						label={getItemAriaLabel('first')}
						width={8}
					/>
				</button>
			)}

			<button
				className={css.action}
				disabled={isStart || disabled}
				onClick={e => onPageChange(e, page - 1)}
			>
				<StackIcon
					className={css.prev}
					icon='arrow'
					label={getItemAriaLabel('previous')}
					width={8}
				/>
			</button>

			<div className={`${css.information} ${typo.buttonSmB}`}>
				{setPaginationInform()}
			</div>

			<button
				className={css.action}
				disabled={isLast || disabled}
				onClick={e => onPageChange(e, page + 1)}
			>
				<StackIcon icon='arrow' label={getItemAriaLabel('next')} width={8} />
			</button>
			{showLastButton && (
				<button
					className={css.action}
					disabled={isLast || disabled}
					onClick={e => onPageChange(e, pageTotal - 1)}
				>
					<StackIcon
						icon='arrow-double'
						label={getItemAriaLabel('last')}
						width={8}
					/>
				</button>
			)}
		</div>
	)
}
